var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR2Integrations02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.69 235.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{fill:#fff;}.i,.j{fill:none;}.j{stroke:#fff;stroke-miterlimit:10;stroke-width:4.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "i",
    x1: 29.81,
    y1: 133.22,
    x2: 29.75,
    y2: 133.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M29.75,133.23s-.05,.08-.07,.12l.13-.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 65.91,
    cy: 107.38,
    r: 24.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M97.53,165.7v-2.13c0-8.74-3.54-16.64-9.26-22.37-4-3.99-9.05-6.92-14.71-8.32-2.45-.62-5.01-.94-7.65-.94-2.43,0-4.8,.28-7.08,.8-14.06,3.21-24.54,15.8-24.54,30.83v43.9h54.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 58.83,
    y: 131.63,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "62.15 146.28 58.48 169.7 66.54 178.22 73.91 169.7 70.11 146.37 62.15 146.28"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M55.34,85.2s4.58,30.46,35.13,22.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 167.3,
    y: 131.63,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "170.63 146.28 166.96 169.7 175.02 178.22 182.38 169.7 178.59 146.37 170.63 146.28"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 174.38,
    cy: 107.38,
    r: 24.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M152.01,207.47h54v-43.9c0-8.74-3.54-16.64-9.26-22.37-4-3.99-9.05-6.92-14.71-8.32-2.45-.62-5.02-.94-7.66-.94-2.43,0-4.8,.28-7.08,.8-14.05,3.21-24.54,15.8-24.54,30.83v1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M164.43,85.2s4.58,30.46,35.13,22.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 113.3,
    y: 155.63,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "116.63 170.28 112.96 193.7 121.02 202.22 128.38 193.7 124.59 170.37 116.63 170.28"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 120.38,
    cy: 131.38,
    r: 24.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M120.38,155.94h0c17.45,0,31.62,14.17,31.62,31.62v43.9h-63.25v-43.9c0-17.45,14.17-31.62,31.62-31.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M172.27,53.25c-1.7,1.61-3.38,3.09-4.9,4.71-.47,.5-.8,1.44-.71,2.11,.95,7.14-1.7,9.97-8.83,9.29-.15-.01-.31,.09-.46,.14-1.55,7.04-3.47,8.96-8.76,9.39-1.29,2.52-1.94,5.24-3.66,6.72-1.69,1.45-4.46,1.64-7.14,2.5-2.09,5.96-3.81,7.01-10.87,6.13-.91-.11-1.83-.19-2.7-.45-2.78-.81-4.91-.14-7.16,1.87-4.2,3.75-10.88,1.27-12.15-4.25-.15-.64-.24-1.3-.36-1.93-7.37-.72-8.29-1.5-9.94-8.3-6.68-.18-9.27-2.7-9.36-8.97-1.66-.61-3.41-.97-4.85-1.85-2.89-1.77-4.24-5.38-2.77-8.5,1.12-2.37,.3-3.66-1.23-5.1-.54-.51-1-1.11-1.62-1.81-.4,.49-.8,.87-1.07,1.33-.87,1.49-2.04,1.89-3.55,1.02-5.11-2.95-10.23-5.89-15.32-8.87-1.7-1-1.48-2.38-.62-3.85,4.83-8.34,9.66-16.7,14.48-25.04,2.33-4.03,4.71-8.03,6.98-12.09,1.03-1.84,2.27-2.2,4.09-1.13,4.3,2.52,8.63,5,12.97,7.46,3.88,2.21,3.91,2.25,1.91,6.55,3.07,2.53,6.67,4.13,10.45,5.34,.36,.12,1.13-.3,1.38-.69,3.86-5.92,9.88-7.4,16.28-7.54,7.72-.17,15.45,.16,23.18,.27,1.8,.02,3.61,0,5.7,0-1.34-2.8,.2-3.94,2.21-5.05,4.36-2.42,8.63-5,12.95-7.49,2.58-1.49,3.41-1.32,4.84,1.15,7.08,12.23,14.12,24.48,21.21,36.71,1.15,1.99,.84,3.31-1.25,4.45-4.52,2.47-8.94,5.13-13.42,7.68-3.19,1.81-3.26,1.78-5.3-1.2-.17-.25-.41-.47-.62-.71Zm-49.4,37.75c3.01,.23,5.71,.61,8.42,.6,2.47-.01,3.19-1.97,3.67-4.04,.46-1.99-1.21-2.08-2.27-2.65-1.91-1.01-3.94-1.81-5.77-2.93-.74-.45-1.75-1.77-1.55-2.24,.66-1.6,1.87-.64,2.89-.13,2.67,1.34,5.31,2.76,8.05,3.96,1.33,.58,2.85,1.03,4.28,1.04,2.07,.01,3.72-1.04,4.09-3.28,.34-2.07,.06-3.81-2.14-5.02-4.73-2.61-9.36-5.4-13.94-8.26-.75-.47-1.01-1.71-1.5-2.59,.95,.06,2.06-.18,2.81,.23,3.34,1.85,6.58,3.89,9.87,5.84,2.36,1.4,4.68,2.88,7.14,4.09,2.61,1.29,5.17,.16,6.6-2.64,1.46-2.86,.94-4.83-1.67-6.48-5.26-3.34-10.54-6.66-15.73-10.1-.7-.46-.93-1.63-1.38-2.47,.93,.06,2.07-.2,2.77,.24,5.52,3.39,10.91,7.01,16.46,10.35,1.8,1.08,3.91,1.86,5.97,2.24,2.4,.44,3.76-.81,4.11-3.26,.4-2.81-.63-5.02-2.97-6.66-5.3-3.73-10.54-7.56-15.88-11.22-5.07-3.47-10.12-6.99-15.4-10.12-4.9-2.91-5.85-2.52-9.78,1.58-2.3,2.4-4.58,4.84-7.13,6.95-3.46,2.88-8.17,2.68-11.71-.15-2.99-2.4-3.59-6.35-1.37-9.5,1.37-1.95,2.83-3.83,4.25-5.76-3.81-1.88-7.41-3.66-11.13-5.5-5.46,9.44-10.88,18.78-16.25,28.15-.22,.39-.22,1.2,.04,1.52,1.27,1.6,2.67,3.09,4.1,4.71,2.59-2.47,5.19-4.14,8.69-3.31,3.55,.85,5.24,3.41,6.06,7.09,3.3-3.19,6.58-5.65,11.07-3.38,3.61,1.83,4.52,5.06,4.15,8.75,7.01,2.26,8.09,4.02,7.19,11.58,6.26,2.78,7.81,6.4,4.91,12.79Zm42.32-34.76c1.39-1.48,3.07-2.98,4.35-4.77,.51-.71,.57-2.27,.13-3.05-5.01-8.91-10.13-17.76-15.32-26.57-.4-.68-1.5-1.28-2.31-1.32-5.89-.28-11.8-.59-17.69-.54-5.47,.05-10.95,.42-16.4,.85-3.58,.28-6.42,2.11-8.54,5.03-2.29,3.16-4.63,6.29-6.93,9.44-2.23,3.06-1.08,6.42,2.58,7.55,2.5,.77,4.76,.45,6.68-1.47,2.76-2.76,5.47-5.57,8.31-8.25,2.98-2.81,5.5-3.12,9.07-1.2,2.63,1.42,5.28,2.83,7.74,4.52,9.37,6.45,18.67,13.02,28.33,19.78Zm-93.83-1.43c7.28-12.62,14.45-25.03,21.69-37.58-5.1-2.94-9.94-5.74-14.84-8.57-7.29,12.63-14.42,24.97-21.68,37.54,4.99,2.9,9.85,5.71,14.83,8.61Zm104.43-1.47c4.98-2.89,9.83-5.71,14.83-8.62-7.28-12.61-14.41-24.96-21.69-37.56-5.05,2.94-9.88,5.75-14.81,8.63,7.31,12.66,14.44,25.02,21.68,37.55Zm-67.7,11.9c-.17-.96-.75-3.43-2.76-4.83-.74-.51-1.31-.63-1.43-.65-1.31-.26-2.67,.29-3.84,1.28-3.35,2.85-6.7,5.71-9.98,8.64-2.36,2.11-2.63,4.95-.79,7.04,1.76,2,4.58,2.22,6.9,.32,2.98-2.44,7.09-4,10.2-8.76,.8-1.22,1.35-2.3,1.7-3.04Zm6.99,9.48c-.01-.48-.13-2.94-1.97-4.29-.22-.16-.72-.52-1.45-.68-1.32-.29-2.7,.22-3.87,1.17-2.71,2.2-5.36,4.47-7.96,6.8-2.56,2.31-2.88,5.05-.98,7.23,1.92,2.2,4.64,2.28,7.32,.09,3.07-2.52,5.85-3.42,7.54-6.52,.81-1.49,1.18-2.87,1.36-3.8Zm-7.5,15.01c-.06,3.68,3.72,6.18,6.92,4.27,2.3-1.37,4.43-3.24,6.17-5.29,2.25-2.64,.31-6.92-3.1-7.44-3.35-.51-9.94,5.07-9.99,8.46Zm-18.69-32.96c-3.78,.01-8.36,3.89-8.86,6.56-.38,2.02,.31,3.64,1.95,4.78,1.74,1.2,3.65,1.2,5.38,.02,1.36-.93,2.66-2.02,3.8-3.22,1.44-1.5,2.03-3.48,.87-5.25-.9-1.37-2.49-2.3-3.15-2.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2Integrations02);
export default __webpack_public_path__ + "static/media/R2_Integrations-02.6c069980683f4c0ac2b8d2ffc4d830ee.svg";
export { ForwardRef as ReactComponent };